import tailwindConfig from '../../../../tailwind.config';

type Props = {
  size: number;
  color?: string;
};

const Phone = ({ size, color = tailwindConfig.theme.colors.gray[600] }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.80823 5.34395L13.2002 8.91195C13.4746 9.20782 13.6271 9.59643 13.6271 9.99995C13.6271 10.4035 13.4746 10.7921 13.2002 11.088L11.8242 12.496C11.5626 12.7742 11.4092 13.1367 11.3916 13.5182C11.374 13.8997 11.4934 14.2748 11.7282 14.576L17.4562 20.256C17.7508 20.4699 18.1095 20.5769 18.4731 20.5595C18.8367 20.542 19.1835 20.4011 19.4562 20.16L21.0562 18.72C21.3521 18.4456 21.7407 18.2931 22.1442 18.2931C22.5477 18.2931 22.9364 18.4456 23.2322 18.72L26.7522 22.24C27.0221 22.5349 27.1717 22.9202 27.1717 23.32C27.1717 23.7197 27.0221 24.105 26.7522 24.4L25.9042 25.344C25.155 26.2069 24.1224 26.7743 22.9922 26.944C22.5581 27.0094 22.1191 27.0362 21.6802 27.024C19.951 27.0249 18.2576 26.5308 16.8002 25.6L15.2002 24.432C14.29 23.788 13.4339 23.071 12.6402 22.288L10.4802 20.112C8.7194 18.3297 7.15818 16.3607 5.82423 14.24V14.24C5.09516 12.691 4.74421 10.991 4.80023 9.27995C4.86236 8.26567 5.32236 7.31691 6.08023 6.63995L7.60023 5.26395C7.90795 4.99083 8.30907 4.84675 8.72025 4.86165C9.13143 4.87654 9.52107 5.04927 9.80823 5.34395V5.34395Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Phone;
